import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../state/store";
import { getInformationAction } from "../../../../state/usecase/care_recipient/actions";
import { useSelectCareRecipientFromPath } from "../../../hooks/care_recipient/useSelectCareRecipientFromPath";
import { useSendLocationToGtag } from "../../../hooks/common/useSendLocationToGtag";
import { CareRecipientInformation } from "./components/CareRecipientInformation";
import { CareRecipientConfigProvider } from "../../../provider/CareRecipientConfigProvider";
import { ConfigTabs } from "./tab_panel/ConfigTabs";
import { useChangeCareRecipient } from "../../../hooks/common/useChangeCareRecipient";
import { Paths } from "../../../../Paths";
import { useScrollTop } from "../../../hooks/common/useScrollTop";

export function CareRecipientConfigPage() {
    useSelectCareRecipientFromPath();

    const dispatch = useAppDispatch();

    useSendLocationToGtag("利用者設定");

    const careRecipientId = useChangeCareRecipient(`${Paths.careRecipient}${Paths.config}`);

    useScrollTop();

    useEffect(() => {
        if (!careRecipientId) return;
        dispatch(getInformationAction(careRecipientId));
    }, [dispatch, careRecipientId]);

    return (
        <CareRecipientConfigProvider>
            <div className={"config_page"}>
                <div className={"container"}>
                    <CareRecipientInformation />
                    <ConfigTabs />
                </div>
            </div>
        </CareRecipientConfigProvider>
    );
}
